<template>
  <div>
    <!-- Header -->
    <div class="header bg-gradient-success py-7 py-lg-8 pt-lg-9">
      <b-container>
        <div class="header-body text-center mb-7">
          <b-row class="justify-content-center">
            <b-col xl="5" lg="6" md="8" class="px-5">
              <h1 class="text-white">Welcome!</h1>
            </b-col>
          </b-row>
        </div>
      </b-container>
      <div class="separator separator-bottom separator-skew zindex-100">
        <svg x="0" y="0" viewBox="0 0 2560 100" preserveAspectRatio="none" version="1.1"
             xmlns="http://www.w3.org/2000/svg">
          <polygon class="fill-default" points="2560 0 2560 100 0 100"></polygon>
        </svg>
      </div>
    </div>
    <!-- Page content -->
    <b-container class="mt--8 pb-5">
      <b-row class="justify-content-center">
        <b-col lg="5" md="7">
          <b-card no-body class="bg-secondary border-0 mb-0">
            <b-card-header class="bg-transparent pb-5"  >
              <div class="text-muted text-center mt-2 mb-3"><small>Sign in with</small></div>
              <div class="btn-wrapper text-center">
                <a href="#" class="btn btn-neutral btn-icon">
                  <span class="btn-inner--icon"><img src="img/icons/common/github.svg"></span>
                  <span class="btn-inner--text">Github</span>
                </a>
                <a href="#" class="btn btn-neutral btn-icon">
                  <span class="btn-inner--icon"><img src="img/icons/common/google.svg"></span>
                  <span class="btn-inner--text">Google</span>
                </a>
              </div>
            </b-card-header>
            <b-card-body class="px-lg-5 py-lg-5">
              <div class="text-center text-muted mb-4">
                <small>Or sign in with credentials</small>
              </div>
              <validation-observer v-slot="{handleSubmit}" ref="formValidator">
                <b-form role="form" @submit.prevent="handleSubmit(onSubmit)">
                  <base-input alternative
                              class="mb-3"
                              name="Username"
                              :rules="{required: true}"
                              prepend-icon="ni ni-circle-08"
                              placeholder="Username"
                              v-model="model.username">
                  </base-input>

                  <base-input alternative
                              class="mb-3"
                              name="Password"
                              :rules="{required: true}"
                              prepend-icon="ni ni-lock-circle-open"
                              type="password"
                              placeholder="Password"
                              v-model="model.password">
                  </base-input>

                  <p v-if="loginError!==null" style="color:red">{{loginError}}</p>

                  <b-form-checkbox v-model="model.rememberMe">Remember me</b-form-checkbox>
                  <div class="text-center">
                    <base-button type="primary" native-type="submit" class="my-4">Sign in</base-button>
                  </div>
                </b-form>
              </validation-observer>
            </b-card-body>
          </b-card>
          <b-row class="mt-3">
            <b-col cols="6">
              <router-link to="/dashboard" class="text-light"><small>Forgot password?</small></router-link>
            </b-col>
            <b-col cols="6" class="text-right">
              <router-link to="/register" class="text-light"><small>Create new account</small></router-link>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
  import AuthService from '@/services/AuthService.js';

  export default {
    data() {
      return {
        model: {
          username: '',
          password: '',
          rememberMe: false
        },

        loginError:null,
      };
    },
    async created(){
      if(AuthService.isLoggedIn()){
        this.$notify({
          message: 'Already logged in',
          type: 'info',
          size: 'lg',
          timeout: 5000,
          showClose: true
        });
        this.$router.push({name:'dashboard'});
      }
      else if(AuthService.isRememberingUser()){
        await this.login(localStorage.getItem('username'),localStorage.getItem('passworn'),false);
      }
      
    },
    methods: {
      async onSubmit() {
        // this will be called only after form is valid. You can do api call here to login
        // if(this.model.rememberMe)
        //   AuthService.rememberUser(this.model.username,this.model.password);
      
        await this.login(this.model.username,this.model.password, this.model.rememberMe)
      },
      async login(username,password,rememberMe){
        var loginStatus = await AuthService.login(username,password, rememberMe);
        if(loginStatus===true){
          this.$router.push({name:'dashboard'}); // TODO: Buraya en son sayfaya gidecek kodu yaz
        }
        else{
          this.loginError=loginStatus;
        }
        // AuthRepository.login(username,password).then((response) => {
        //   AuthService.setCredentials(response.data.access,response.data.refresh,true);
        //   this.$router.push({name:'dashboard'});
        // }, function(error) {
        //   AuthService.clearCredentials();
        //   AuthService.forgetUser();
        //   // TODO: hatalı kullanıcı adı - şifre
        // })
      }
    }
  };
</script>
